<template>
  <div id="SeasonSuites">
    <div class="top">
      <b-container>
        <div class="title">
          As a <span>season suite</span> member, you’ll receive these premium
          suite amenities:
        </div>
        <div class="perks">
          <div
            class="perk"
            v-for="(perk, index) in perks"
            :key="'perk' + index"
          >
            <div class="icon">
              <img :src="require('@/assets/icons/Benefits/' + perk.icon)" />
            </div>
            <p v-html="perk.description" />
          </div>
        </div>
      </b-container>
    </div>
    <div class="bottom">
      <b-container>
        <div class="controller">
          <div class="item item1" @click="activeItem('field')">
            <div class="title">field</div>
            <div class="title">suites</div>
            <div class="overlay" :class="{ active: activeClasses.field }" />
          </div>
          <div class="item item2" @click="activeItem('founders')">
            <div class="title">founders</div>
            <div class="title">suites</div>
            <div class="overlay" :class="{ active: activeClasses.founders }" />
          </div>
          <div class="item item3" @click="activeItem('legacy')">
            <div class="title">legacy</div>
            <div class="title">suites</div>
            <div class="overlay" :class="{ active: activeClasses.legacy }" />
          </div>
          <div class="item item4" @click="activeItem('classic')">
            <div class="title">classic</div>
            <div class="title">suites</div>
            <div class="overlay" :class="{ active: activeClasses.classic }" />
          </div>
          <div
            class="arrow"
            :class="{
              field: activeClasses.field,
              founders: activeClasses.founders,
              legacy: activeClasses.legacy,
              classic: activeClasses.classic,
            }"
          >
            <img src="@/assets/icons/icon_arrow-karet-big-white.svg" />
          </div>
        </div>
        <div class="suitesItems">
          <div
            class="suitesItem"
            v-for="(item, index) in suitesData"
            :key="'item' + index"
            :class="activeClass(item.class)"
          >
            <div class="suitesItem__top">
              <div class="description" v-html="item.description" />
              <div class="right">
                <div class="title">
                  all <span>{{ item.title }}</span> members will enjoy:
                </div>
                <div class="perks">
                  <div
                    class="perk"
                    v-for="perk in item.perks"
                    :key="'perk' + index + perk.text"
                  >
                    <div class="icon">
                      <img :src="perk.icon" />
                    </div>
                    <h4 v-html="perk.text" />
                  </div>
                </div>
              </div>
            </div>
            <div class="suites-info" :class="item.class">
              <b-carousel id="SuitesCarousel" controls>
                <b-carousel-slide
                  v-for="(image, index) in item.slider"
                  :key="'image' + index"
                  :img-src="image"
                >
                </b-carousel-slide>
              </b-carousel>
            </div>
            <div
              class="accordion2"
              v-for="(accordionItem, index) in item.accordion"
              :key="'accordionItem' + index"
              @click="itemClicked2('suite' + item.class + index)"
            >
              <div class="accordion-item">
                <div class="accordion-item-content">
                  <div class="left">
                    <img :src="accordionItem.icon" />
                    <div class="info">
                      <h1>{{ accordionItem.title }}</h1>
                      <p>{{ accordionItem.description }}</p>
                    </div>
                  </div>

                  <div :id="'icon' + index" class="downArrow">
                    <img src="@/assets/icons/icon_arrow-karet-big.svg" />
                  </div>
                </div>
                <div
                  :id="'suite' + item.class + index"
                  class="description-container"
                >
                  <div class="description-content" v-if="accordionItem.image">
                    <img :src="accordionItem.image" />
                  </div>
                  <div class="description-content compare" v-else>
                    <div
                      class="suite-compare"
                      v-for="(inside, ind) in accordionItem.inside"
                      :key="'inside' + ind"
                    >
                      <div class="title">{{ inside.title }}</div>
                      <div
                        class="descriptions"
                        v-for="descriptions in inside.suiteItems"
                        :key="'descriptions' + descriptions.text"
                      >
                        <img :src="descriptions.icon" />
                        <h4 v-html="descriptions.text" />
                      </div>
                      <!-- <div class="divider" /> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import { seasonData } from "@/data/season.js";
import { TweenLite } from "gsap/dist/gsap";

export default {
  name: "SeasonSuites",
  components: {},
  data() {
    return {
      activeClasses: {
        field: true,
        founders: false,
        legacy: false,
        classic: false,
      },
      perks: [
        {
          icon: "icon_white_baseball.svg",
          description: "spring training<br>trip for 2 to<br>surprise, arizona",
        },
        {
          icon: "icon_white_calendar.svg",
          description:
            "priority access to<br>postseason and<br>Globe Life Field events",
        },
        {
          icon: "icon_white_ticket.svg",
          description:
            "discounted tickets<br>for all regular<br>season home games",
        },
        {
          icon: "icon_white_tshirt.svg",
          description: "merchandise<br>discounts",
        },
        // {
        //   icon: "icon_white_fork-knife.svg",
        //   description: "season ticket<br>member picnic",
        // },
        {
          icon: "icon_white_tshirt.svg",
          description: "invitations to texas<br>rangers events",
        },
      ],
      suitesData: seasonData(),
      activeItemKey1: "",
      activeItemKey2: "",
    };
  },
  methods: {
    activeItem(item) {
      this.activeClasses.field = false;
      this.activeClasses.founders = false;
      this.activeClasses.legacy = false;
      this.activeClasses.classic = false;
      this.activeClasses[item] = true;
    },
    activeClass(itemClass) {
      if (this.activeClasses[itemClass]) {
        return "active";
      }
    },
    itemClicked(itemId) {
      console.log("click", itemId);
      let currentActiveEle = document.getElementById(this.activeItemKey1);
      let activeItemKeyCopy = this.activeItemKey1;
      if (currentActiveEle) {
        this.activeItemKey1 = "";
        TweenLite.to(currentActiveEle, 0.5, {
          height: 0,
        });
        if (itemId == "first") {
          document.getElementById("iconfirst").classList.remove("active");
          document.getElementById("iconsecond").classList.remove("active");
        } else {
          document.getElementById("iconfirst").classList.remove("active");
          document.getElementById("iconsecond").classList.remove("active");
        }
      }
      if (itemId != activeItemKeyCopy) {
        this.activeItemKey1 = itemId;
        let newActiveEle = document.getElementById(itemId);
        TweenLite.to(newActiveEle, 0.5, {
          height: newActiveEle.scrollHeight,
        });
        if (itemId == "first") {
          document.getElementById("iconfirst").classList.add("active");
          document.getElementById("iconsecond").classLists.remove("active");
        } else {
          document.getElementById("iconfirst").classList.remove("active");
          document.getElementById("iconsecond").classList.add("active");
        }
      }
    },
    itemClicked2(itemId) {
      let currentActiveEle = document.getElementById(this.activeItemKey2);
      let activeItemKeyCopy = this.activeItemKey2;
      if (currentActiveEle) {
        this.activeItemKey2 = "";
        TweenLite.to(currentActiveEle, 0.5, {
          height: 0,
        });
        if (itemId == "suitefield0") {
          document.getElementById("icon0").classList.remove("active");
          document.getElementById("icon1").classList.remove("active");
        } else {
          document.getElementById("icon0").classList.remove("active");
          document.getElementById("icon1").classList.remove("active");
        }
      }
      if (itemId != activeItemKeyCopy) {
        this.activeItemKey2 = itemId;
        let newActiveEle = document.getElementById(itemId);
        TweenLite.to(newActiveEle, 0.5, {
          height: newActiveEle.scrollHeight,
        });
        if (itemId == "suitefield0") {
          document.getElementById("icon0").classList.add("active");
          document.getElementById("icon1").classLists.remove("active");
        } else {
          document.getElementById("icon0").classList.remove("active");
          document.getElementById("icon1").classList.add("active");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#SeasonSuites {
  display: flex;
  flex-direction: column;
  width: 100%;
  .top {
    width: 100%;
    background: linear-gradient(135deg, #252525 0%, #111111 100%);
    padding: 100px 0 200px 0;
    .container {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .title {
      font-family: BertholdCondensed;
      font-size: 15px;
      letter-spacing: 0;
      line-height: 16px;
      font-weight: 700;
      color: #ffffff;
      text-transform: uppercase;
      width: fit-content;
      padding: 10px 0;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      span {
        color: #c10230;
      }
    }
    .perks {
      display: flex;
      flex-direction: row;
      justify-content: center;
      width: 100%;
      margin-top: 43px;
      @media (max-width: $md) {
        flex-wrap: wrap;
        margin-top: 5px;
      }
      .perk {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 50px;
        &:last-child {
          margin-right: 0;
        }
        @media (max-width: $md) {
          width: calc(50% - 25px);
          margin-top: 33.5px;
          &:nth-child(even) {
            margin-right: 0;
          }
        }
        .icon {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 50px;
          width: 50px;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.1);
          margin-bottom: 13.5px;
          img {
            height: 19.81px;
            width: 21.63px;
            object-fit: contain;
          }
        }
        p {
          font-family: BertholdCondensed;
          font-size: 15px;
          letter-spacing: 0;
          line-height: 16px;
          font-weight: 700;
          color: #ffffff;
          text-transform: uppercase;
          text-align: center;
        }
      }
    }
  }
  .bottom {
    width: 100%;
    background-image: url("~@/assets/images/backgrounds/bg_season-suites.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    padding-bottom: 44px;
    .container {
      display: flex;
      flex-direction: column;
    }
    .controller {
      position: relative;
      display: flex;
      flex-direction: row;
      width: 100%;
      border-top: 1px solid #ffffff;
      border-bottom: 5px solid #ffffff;
      margin-top: -95.094px;
      margin-bottom: 12px;
      @media (max-width: $md) {
        border-top: 5px solid #ffffff;
        border-bottom: none;
        flex-wrap: wrap;
      }
      .arrow {
        position: absolute;
        bottom: -26px;
        @media (max-width: $md) {
          display: none;
        }
        &.field {
          left: 16px;
          transition: left 0.5s ease-in-out;
        }
        &.founders {
          left: calc(25% + 16px);
          transition: left 0.5s ease-in-out;
        }
        &.legacy {
          left: calc(50% + 16px);
          transition: left 0.5s ease-in-out;
        }
        &.classic {
          left: calc(75% + 16px);
          transition: left 0.5s ease-in-out;
        }
      }
      .item {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-start;
        padding: 0 0 16px 16px;
        height: 184.19px;
        width: calc(100% / 3);
        background-size: cover;
        background-repeat: no-repeat;
        cursor: pointer;
        @media (max-width: $md) {
          height: 100px;
          width: 50%;
          align-items: center;
          padding: 0 0 16px 0;
        }
        &.item1 {
          background-image: url("~@/assets/images/SeasonSuites/FieldSuites/field_1.jpg");
          @media (max-width: $md) {
            background-image: none;
          }
        }
        &.item2 {
          background-image: url("~@/assets/images/SeasonSuites/FoundersSuites/founders_1.jpg");
          @media (max-width: $md) {
            background-image: none;
          }
        }
        &.item3 {
          background-image: url("~@/assets/images/SeasonSuites/Legacy/legacy_1.jpg");
          @media (max-width: $md) {
            background-image: none;
          }
        }
        &.item4 {
          background-image: url("~@/assets/images/SeasonSuites/ClassicSuites/classic_season20_1.jpg");
          @media (max-width: $md) {
            background-image: none;
          }
        }
        .title {
          font-family: BertholdCondensed;
          font-size: 25px;
          line-height: 23px;
          letter-spacing: 0;
          color: $dark-blue;
          font-weight: 700;
          background: #ffffff;
          text-transform: uppercase;
          padding: 4px;
          &:first-child {
            margin-bottom: 1px;
          }
        }
        .overlay {
          position: absolute;
          top: 0;
          left: 0;
          height: calc(100% + 5px);
          width: 100%;
          background-color: rgba(4, 12, 24, 0.7);
          z-index: 2;
          transition: background-color 0.3s ease-in-out;
          &.active {
            background-color: transparent;
            transition: background-color 0.3s ease-in-out;
          }
        }
      }
    }
    .suitesItems {
      width: 100%;
      .suitesItem {
        // display: flex;
        display: none;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 0;
        margin-top: 80px;
        @media (max-width: $lg) {
          margin-top: 40px;
        }
        &.active {
          display: flex;
          height: fit-content;
        }
        &__top {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          width: 100%;
          margin-bottom: 97px;
          @media (max-width: $lg) {
            flex-direction: column;
            margin-bottom: 35px;
          }
          .description {
            font-size: 16px;
            line-height: 23px;
            color: #ffffff;
            text-align: center;
            letter-spacing: 0;
            width: calc(50% - 27.5px);
            @media (max-width: $lg) {
              width: 100%;
            }
          }
          .right {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: calc(50% - 27.5px);
            @media (max-width: $lg) {
              width: 100%;
              margin-top: 25px;
            }
            .title {
              font-family: BertholdCondensed;
              font-size: 15px;
              line-height: 16px;
              letter-spacing: 0;
              color: #ffffff;
              font-weight: 700;
              text-transform: uppercase;
              width: fit-content;
              padding: 11px 0;
              border-top: 1px solid rgba(255, 255, 255, 0.1);
              border-bottom: 1px solid rgba(255, 255, 255, 0.1);
              margin-bottom: 27px;
            }
            .perks {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              justify-content: space-between;
              @media (max-width: $sm) {
                flex-direction: column;
                flex-wrap: nowrap;
              }
              .perk {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: calc(50% - 15px);
                margin-bottom: 14px;
                @media (max-width: $sm) {
                  width: 100%;
                }
                .icon {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 50px;
                  height: 50px;
                  border-radius: 50%;
                  background: #ffffff;
                  margin-right: 17px;
                }
                h4 {
                  font-family: BertholdCondensed;
                  font-size: 15px;
                  line-height: 16px;
                  letter-spacing: 0;
                  color: #ffffff;
                  font-weight: 700;
                  text-transform: uppercase;
                  max-width: 108px;
                  margin: 0;
                  text-align: start;
                }
              }
            }
          }
        }
        .suites-info {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          width: 100%;
          padding: 24px 0;
          border-bottom: 1px solid rgba(255, 255, 255, 0.25);
          margin-bottom: 24px;
        }
        .accordion2 {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-content: center;
          width: 100%;
          margin-bottom: 8px;
          .accordion-item {
            border-radius: 3px;
            overflow: hidden;
            width: 100%;
            max-width: 100%;
            background: #ffffff;
            cursor: pointer;
            .accordion-item-content {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              padding: 29px 24px 24px 24px;
              .left {
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                margin: 0;
                img {
                  margin-right: 16.37px;
                }
                .info {
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  h1 {
                    font-family: "BertholdCondensed";
                    font-size: 25px;
                    letter-spacing: 0;
                    line-height: 23px;
                    font-weight: 700;
                    color: $dark-blue;
                    text-transform: uppercase;
                    margin-bottom: 4px;
                  }
                  p {
                    font-size: 12px;
                    line-height: 17px;
                    letter-spacing: 0;
                    color: $dark-blue;
                    margin-bottom: 0;
                  }
                }
              }
            }
            .downArrow {
              display: flex;
              justify-content: center;
              align-items: center;
              transform: rotate(0deg);
              transition: transform 0.5s ease-in-out;
              width: 50px;
              height: 50px;
              background-color: #259ef3;
              border-radius: 50%;
              &.active {
                transform: rotate(180deg);
                transition: transform 0.5s ease-in-out;
              }
            }
            .description-container {
              height: 0;
            }
            .description-content {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              padding: 8px 24px 8px 22px;
              &.compare {
                flex-direction: row;
                background: linear-gradient(135deg, #0060aa 0%, #081c3a 100%);
                border-left: 1px solid #ffffff;
                border-right: 1px solid #ffffff;
                border-bottom: 1px solid #ffffff;
                border-radius: 0 0 3px 3px;
                padding: 44px 8px;
                height: fit-content;
                @media (max-width: $lg) {
                  flex-direction: column;
                  padding: 0 8px;
                }
              }
              img {
                width: 100%;
                object-fit: contain;
              }
              .suite-compare {
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                width: calc(100% / 4);
                max-width: 280px;
                height: 303px;
                padding: 0 45px;
                &:nth-child(2) {
                  border-left: 1px solid rgba(255, 255, 255, 0.1);
                  border-right: 1px solid rgba(255, 255, 255, 0.1);
                  @media (max-width: $lg) {
                    border-left: none;
                    border-right: none;
                    border-top: 1px solid rgba(255, 255, 255, 0.1);
                    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                  }
                }
                &:last-child {
                  border-left: 1px solid rgba(255, 255, 255, 0.1);
                  @media (max-width: $lg) {
                    border-left: none;
                    border-right: none;
                    border-top: 1px solid rgba(255, 255, 255, 0.1);
                  }
                }
                @media (max-width: $xl) {
                  height: 319px;
                }
                @media (max-width: $lg) {
                  width: calc(100% - 90px);
                  max-width: 100%;
                  height: fit-content;
                  margin: 0 45px;
                  padding: 24px 0;
                }
                .title {
                  font-size: 13px;
                  line-height: 15px;
                  letter-spacing: normal;
                  font-weight: 900;
                  color: #002d74;
                  background-color: #ffffff;
                  text-transform: uppercase;
                  width: fit-content;
                  padding: 1px 2px;
                  margin-bottom: 22px;
                }
                .descriptions {
                  display: flex;
                  flex-direction: row;
                  img {
                    height: 14.11px;
                    width: 12px;
                    object-fit: contain;
                    margin-right: 12.62px;
                  }
                  h4 {
                    font-family: BertholdCondensed;
                    font-size: 15px;
                    line-height: 16px;
                    letter-spacing: normal;
                    font-weight: 700;
                    font-style: normal;
                    color: $light-blue;
                    text-transform: uppercase;
                    text-align: start;
                  }
                }
                // .divider {
                //   position: absolute;
                //   right: 0;
                //   top: 0;
                //   height: 100%;
                //   width: 1px;
                //   background: rgba(255,255,255,0.1);
                // }
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
#SeasonSuites {
  .suitesItem {
    span {
      color: #c10230;
    }
    .description {
      span {
        font-weight: 700;
      }
    }
  }
  .suite-compare {
    span {
      font-weight: normal;
    }
  }
  #SuitesCarousel {
    border-bottom: 5px solid #ffffff;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 20.81px;
    .carousel-control-next-icon {
      background-image: url("~@/assets/icons/icon_gallery-arrow-right.svg");
    }
    .carousel-control-prev-icon {
      background-image: url("~@/assets/icons/icon_gallery-arrow-left.svg");
    }
    .carousel-control-next-icon,
    .carousel-control-prev-icon {
      width: 70px;
      height: 70px;
    }
    .carousel-control-next,
    .carousel-control-prev {
      width: 125px;
      opacity: 1;
    }
    .carousel-control-next {
      background: linear-gradient(
        270deg,
        rgba(4, 12, 24, 0.6) 0%,
        rgba(4, 12, 24, 0) 100%
      );
    }
    .carousel-control-prev {
      background: linear-gradient(
        270deg,
        rgba(4, 12, 24, 0) 0%,
        rgba(4, 12, 24, 0.6) 100%
      );
    }
  }
}
</style>
